module.exports = __webpack_public_path__ + "img/vvv-raw-black.5ffd00d5.png";